<template>
  <div class="memory_box">
    <div></div>
    <div class="memory_main">
      <div style=""></div>

      <div>
        <div>
          <div
            style="overflow: hidden; width: 100%; height: 100%; position: fixed; left: 0px; top: 0px;"
          >
            <div
              v-if="templateData[myTemplateId]"
              class="tomb-live-wrap"
              :style="'background-image: url(' + templateData[myTemplateId].bg1 + ');'"
            ></div>
            <div
              v-if="templateData[myTemplateId]"
              class="tomb_stone_bg"
              :style="
                'background-image: url(' +
                  templateData[myTemplateId].bg2 +
                  '); height: 68.533vw;position: relative;top: 24.347vw;'
              "
            >
              <div
                v-if="hall.hallCount.value == '2'"
                class="tomb-head-wrap double-wrap"
                style="top: 31vw;"
              >
                <div class="head-item" style="margin-right: 9px;">
                  <img :src="hall.firstPhoto" />
                  <span class="head-name">{{ hall.firstName }}</span>
                </div>
                <div class="head-item">
                  <img :src="hall.secondPhoto" />
                  <span class="head-name">{{ hall.secondName }}</span>
                </div>
              </div>
              <div v-else class="tomb_stone_wrap" style="margin-top: 30.347vw;">
                <div>
                  <div class="tomb-head-wrap">
                    <img :src="hall.firstPhoto" />
                    <span class="head-name">{{ hall.firstName }}</span>
                  </div>
                </div>

                <!-- <div class="wreath-wrap">
                  <div class="wreath-left">
                    <img src="../../assets/jnt/hua.png" />
                  </div>
                  <div class="wreath-right">
                    <img src="../../assets/jnt/hua.png" />
                  </div>
                </div> -->
              </div>
              <!-- grass -->
              <div class="grass-wrap">
                <div
                  :class="grassShouFlag ? 'grass_small1 delayUp1' : 'grass_small1'"
                  :style="grassShouFlag ? 'animation-delay: 2s;' : ''"
                >
                  <img src="../../assets/jnt/cao1.png" />
                </div>
                <div
                  :class="grassShouFlag ? 'grass_small2 delayUp1' : 'grass_small2'"
                  :style="grassShouFlag ? 'animation-delay: 4s;' : ''"
                >
                  <img src="../../assets/jnt/cao2.png" />
                </div>
                <div id="grassWrap">
                  <div
                    :class="
                      grassShouFlag ? 'grass-item grass-item_1 weedAni' : 'grass-item grass-item_1'
                    "
                    :style="grassShouFlag ? 'animation-delay: 1s;' : ''"
                    data-t="1655190402640"
                  >
                    <img src="../../assets/jnt/grassi1.jpg" />
                  </div>
                  <div
                    :class="
                      grassShouFlag ? 'grass-item grass-item_3 weedAni' : 'grass-item grass-item_3'
                    "
                    :style="grassShouFlag ? 'animation-delay: 2s;' : ''"
                    data-t="1655190402690"
                  >
                    <img src="../../assets/jnt/grassi3.png" />
                  </div>
                  <div
                    :class="
                      grassShouFlag ? 'grass-item grass-item_5 weedAni' : 'grass-item grass-item_5'
                    "
                    :style="grassShouFlag ? 'animation-delay: 3s;' : ''"
                  >
                    <img src="../../assets/jnt/grassi5.jpg" />
                  </div>
                  <div
                    :class="
                      grassShouFlag ? 'grass-item grass-item_2 weedAni' : 'grass-item grass-item_2'
                    "
                    :style="grassShouFlag ? 'animation-delay: 4s;' : ''"
                  >
                    <img src="../../assets/jnt/grassi2.jpg" />
                  </div>
                  <div
                    :class="
                      grassShouFlag ? 'grass-item grass-item_4 weedAni' : 'grass-item grass-item_4'
                    "
                    :style="grassShouFlag ? 'animation-delay: 5s;' : ''"
                  >
                    <img src="../../assets/jnt/grassi4.jpg" />
                  </div>
                </div>
              </div>
              <div v-if="grassShouFlag" class="weed-wrap">
                <div class="glove-wrap"></div>
              </div>
              <div v-if="jimaoClearFlag" class="wipe-wrap" style="width: 35.2vw;">
                <div class="feather-duster-left"><img src="../../assets/jnt/zmt.png" /></div>
                <div class="feather-duster-right"><img src="../../assets/jnt/ymt.png" /></div>
                <div class="shine shine1"></div>
                <div class="shine shine2"></div>
                <div class="shine shine3"></div>
                <div class="shine shine4"></div>
                <div class="shine shine5"></div>
              </div>
              <!--  -->
              <!-- 蜡烛 -->
              <div class="candle_wrap">
                <!-- 香炉 -->
                <div class="center_wrap">
                  <swiper :options="xlOption" ref="xlSwiper" style="height:15vw;">
                    <swiper-slide v-for="(item, index) in xlList" :key="index" class="center-item">
                      <img class="center-item" :src="item" />
                    </swiper-slide>
                  </swiper>
                </div>
              </div>

              <!-- lazhu -->
              <div class="lazhu-wrap">
                <swiper :options="lazhuOption" ref="lazhuSwiper">
                  <swiper-slide v-for="(item, index) in lazhuList" :key="index">
                    <div class="lazhu-box">
                      <div class="lazhu-left">
                        <img :src="item" />
                      </div>
                      <div class="lazhu-right">
                        <img :src="item" />
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <!-- jiu -->
              <div class="wine-wrap">
                <swiper :options="wineOption" ref="wineSwiper">
                  <swiper-slide v-for="(item, index) in jiuList" :key="index">
                    <div class="wine-box">
                      <div class="wine-left">
                        <img :src="item" />
                      </div>
                      <div class="wine-right">
                        <img :src="item" />
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 灯 -->
              <div class="light-wrap">
                <swiper :options="lightOption" ref="lightSwiper">
                  <swiper-slide v-for="(item, index) in lightList" :key="index">
                    <div class="light-box">
                      <div class="light-left">
                        <img :src="item" />
                      </div>
                      <div class="light-right">
                        <img :src="item" />
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 富贵竹 -->
              <div class="wreath-wrap">
                <swiper :options="wreathOption" ref="wreathSwiper">
                  <swiper-slide v-for="(item, index) in zuoyouList" :key="index">
                    <div class="wreath-box">
                      <div class="wreath-left">
                        <img :src="item" />
                      </div>
                      <div class="wreath-right">
                        <img :src="item" />
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 水果 -->
              <div class="fruits-wrap">
                <swiper :options="listOption" ref="fruitsSwiper">
                  <swiper-slide v-for="(item, index) in shuiguoListPage" :key="index">
                    <div class="flex-list">
                      <img
                        v-for="(item1, index1) in item.data"
                        :key="index1"
                        class="fruits-item"
                        :src="item1"
                      />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <!-- 花圈 -->
              <div class="circle-wrap">
                <swiper :options="circleOption" ref="circleSwiper">
                  <swiper-slide v-for="(item, index) in zuoyouList1Page" :key="index">
                    <div class="xhflex-list">
                      <img
                        v-for="(item1, index1) in item.data"
                        :key="index1"
                        class="circle-item"
                        :src="item1"
                      />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <!-- 鲜花 -->
              <div class="xianhua-wrap">
                <swiper :options="listOption" ref="xianhuaSwiper">
                  <swiper-slide v-for="(item, index) in xianhuaListPage" :key="index">
                    <div class="xhflex-list">
                      <img
                        v-for="(item1, index1) in item.data"
                        :key="index1"
                        class="xianhua-item"
                        :src="item1"
                      />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>

              <!-- 挂花 -->
              <div class="hangFlowers-wrap" style="bottom: 36.5vw;z-index:9;">
                <swiper v-if="guahuaList.length > 0" :options="huahuanOption" ref="huahuanSwiper">
                  <swiper-slide v-for="(item, index) in guahuaList" :key="index">
                    <img :src="item" alt="" />
                  </swiper-slide>
                </swiper>
                <swiper v-else :options="huahuanOption" ref="huahuanSwiper">
                  <swiper-slide>
                    <img src="" alt="" />
                  </swiper-slide>
                </swiper>
              </div>
              <!-- 火供 -->

              <div class="fireSwiper-wrap">
                <swiper :options="fireOption" ref="fireSwiper">
                  <swiper-slide v-for="(item, index) in huogongList" :key="index">
                    <img class="fire-item" :src="item" />
                  </swiper-slide>
                </swiper>
              </div>
              <!-- <div class="ground-bg"></div> -->
              <!-- 贡品 -->
              <div class="gongpin-wrap">
                <swiper :options="gongpinOption" ref="gongpinSwiper">
                  <swiper-slide v-for="(item, index) in gongpinListPage" :key="index">
                    <div class="gpflex-list">
                      <img
                        v-for="(item1, index1) in item.data"
                        :key="index1"
                        class="gongpin-item"
                        :src="item1"
                      />
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="foods-wrap">
                <div class="fd-img" style="display: flex; justify-content: space-around;">
                  <img
                    v-for="(item, index) in gongpinBigList"
                    :key="index"
                    class="big-rice"
                    :src="item"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="templateData[myTemplateId]"
              class="ground-bg"
              :style="'background-image: url(' + templateData[myTemplateId].bg3 + ');'"
            ></div>

            <div class="tomb-footer-wrap">
              <div class="foot-item" @click="jimaoClear">
                <i class="icon icon-clean-stone"></i><span>擦墓碑</span>
              </div>
              <div class="foot-item" @click="clearGrass">
                <i class="icon icon-weed"></i><span>除草</span>
              </div>
              <div @click="muyuan()" class="foot-item special-bg">
                <i class="icon icon-pray-goods"></i><span>祭品</span>
              </div>
              <div class="foot-item" @click="guibai">
                <i class="icon icon-knell-down"></i><span>跪拜</span>
              </div>
              <div class="foot-item" @click="jugong">
                <i class="icon icon-bow"></i><span>鞠躬</span>
              </div>
            </div>

            <!-- gui -->
            <div class="bow-wrap" v-if="guibaiFlag">
              <img class="svg-img" src="../../assets/jnt/guibai.gif" />
            </div>
            <div class="bow-wrap" v-if="jugongFlag">
              <img class="svg-img" src="../../assets/jnt/jugong.gif" />
            </div>
            <div class="right-menu-wrap">
              <div>
                <div class="menu-item">
                  <div class="icon-img">
                    <img src="../../assets/jnt/jl.png" alt="" />
                  </div>
                </div>
                <span class="menu-item-text">供奉记录</span>
              </div>
            </div>
            <div>
              <div class="mt-offcanvas mt-offcanvas-center" style="z-index: 2000;">
                <div
                  class="mt-offcanvas-inner mt-offcanvas-inner__slide-in-top"
                  style="z-index: 2000;"
                >
                  <div class="goods_dialog-wrap">
                    <i class="inner-box-close"></i>
                    <div class="dialog-head"><img alt="" /><span></span></div>
                    <div class="dialog-con">
                      <div class="dialog-con-img"><img alt="" /></div>
                      <div class="dialog-con-text">
                        <div class="text-top"><span class="nick"></span></div>
                        <div class="text-bottom">
                          <span class="date-time"></span><span class="remain-time">剩余时间:</span>
                        </div>
                      </div>
                    </div>
                    <div class="dialog-btn">我也要供奉</div>
                  </div>
                </div>
              </div>
              <div class="mt-offcanvas-mask"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="maotan">
      <div class="zmt">
        <img src="../../assets/jnt/zmt.png">
      </div>
      <div class="ymt">
        <img src="../../assets/jnt/ymt.png">
      </div>
      
    </div> -->
    <!-- <div class="bacao">
      <div class="shou">
        <img src="../../assets/jnt/bacao.png">
      </div>
    </div> -->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import bus from '../../common/bus'
export default {
  name: 'mourn',
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ['jntTemplateId', 'myTemplateId'],
  data() {
    return {
      id: null,
      //鞭炮 火供  敬酒  水果  贡品  鲜花  挂花 香烛 花圈 富贵竹 天堂鸟 金钱树 万年青 发财树 平安树 幸福树 摇钱树
      huogongList: [], //火供和鞭炮
      guahuaList: [], //挂花
      xiangzhuList: [], //香烛
      jiuList: [], //酒
      shuiguoList: [], //水果
      shuiguoListPage: [], //水果
      gongpinList: [],
      lightList: [], //香烛，灯
      lazhuList: [], //香烛，蜡烛，含有 烛
      xlList: [], //香烛，香炉含有 炉
      gongpinListPage: [],
      gongpinBigList: [],
      gongpinBigListPage: [],
      xianhuaList: [], //包含左右
      xianhuaListPage: [], //
      zuoyouList1: [], //花圈
      zuoyouList1Page: [], //花圈
      zuoyouList: [], // 富贵竹 天堂鸟 金钱树 万年青 发财树 平安树 幸福树 摇钱树
      templateData: [
        {
          bg1: require('../../assets/jnt/muyuan/1/1.jpg'),
          bg2: require('../../assets/jnt/muyuan/1/2.png'),
          bg3: require('../../assets/jnt/muyuan/1/3.png'),
        },
        {
          bg1: require('../../assets/jnt/muyuan/2/1.jpg'),
          bg2: require('../../assets/jnt/muyuan/2/2.png'),
          bg3: require('../../assets/jnt/muyuan/2/3.png'),
        },
        {
          bg1: require('../../assets/jnt/muyuan/3/1.jpg'),
          bg2: require('../../assets/jnt/muyuan/3/2.png'),
          bg3: require('../../assets/jnt/muyuan/3/3.png'),
        },
        {
          bg1: require('../../assets/jnt/muyuan/4/1.jpg'),
          bg2: require('../../assets/jnt/muyuan/4/2.png'),
          bg3: require('../../assets/jnt/muyuan/4/3.png'),
        },
      ],
      lazhuOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      xlOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      wineOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      lightOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      circleOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
      },
      wineOption1: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      wreathOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 9000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      huahuanOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        effect: 'fade',

        fadeEffect: {
          crossFade: true,
        },
      },
      listOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
      },

      fireOption: {
        // init: false,

        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
      },

      gongpinOption: {
        direction: 'vertical',
        autoHeight: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },
      bgImg: require('../../assets/jnt/bwbj.jpg'),
      bwImg: require('../../assets/jnt/bw.png'),
      bwImg2: require('../../assets/jnt/bw1.png'),
      hall: {
        id: 0,
        firstPhoto: '',
        secondPhoto: '',
        title: '',
        hallCount: '',
        firstName: '',
        secondName: '',
      },
      historyList: [],
      grassShouFlag: false,
      jimaoClearFlag: false,
      guibaiFlag: false,
      jugongFlag: false,
    }
  },
  created() {
    let that = this
    bus.$off('memInit')
    bus.$on('memInit', () => {
      that.init()
    })
  },
  mounted() {
    this.init()
  },
  computed: {
    // xlSwiper() {
    //   return this.$refs.xlSwiper.$swiper
    // },
    // lazhuSwiper() {
    //   return this.$refs.lazhuSwiper.$swiper
    // },
    // wineSwiper() {
    //   return this.$refs.wineSwiper.$swiper
    // },
    // lightSwiper() {
    //   return this.$refs.lightSwiper.$swiper
    // },
    // circleSwiper() {
    //   return this.$refs.circleSwiper.$swiper
    // },
    // wreathSwiper() {
    //   return this.$refs.wreathSwiper.$swiper
    // },
    // fruitsSwiper() {
    //   return this.$refs.fruitsSwiper.$swiper
    // },
    // xianhuaSwiper() {
    //   return this.$refs.xianhuaSwiper.$swiper
    // },
    // gongpinSwiper() {
    //   return this.$refs.gongpinSwiper.$swiper
    // },
    // fireSwiper() {
    //   return this.$refs.fireSwiper.$swiper
    // },
    // huahuanSwiper() {
    //   return this.$refs.huahuanSwiper.$swiper
    // },
  },
  methods: {
    init() {
      var params = this.$route.params
      this.id = params['id']
      this.queryHallOne()
      this.queryHistory()
      let that = this
      this.$nextTick(() => {
        setTimeout(() => {
          that.$refs.fireSwiper.$swiper.slideTo(0)
          that.$refs.fireSwiper.$swiper.update()

          that.$refs.xlSwiper.$swiper.slideTo(0)
          that.$refs.xlSwiper.$swiper.update()

          that.$refs.lazhuSwiper.$swiper.slideTo(0)
          that.$refs.lazhuSwiper.$swiper.update()

          that.$refs.wineSwiper.$swiper.slideTo(0)
          that.$refs.wineSwiper.$swiper.update()

          that.$refs.lightSwiper.$swiper.slideTo(0)
          that.$refs.lightSwiper.$swiper.update()

          that.$refs.circleSwiper.$swiper.slideTo(0)
          that.$refs.circleSwiper.$swiper.update()

          that.$refs.wreathSwiper.$swiper.slideTo(0)
          that.$refs.wreathSwiper.$swiper.update()

          that.$refs.fruitsSwiper.$swiper.slideTo(0)
          that.$refs.fruitsSwiper.$swiper.update()

          that.$refs.xianhuaSwiper.$swiper.slideTo(0)
          that.$refs.xianhuaSwiper.$swiper.update()

          that.$refs.gongpinSwiper.$swiper.slideTo(0)
          that.$refs.gongpinSwiper.$swiper.update()

          that.$refs.huahuanSwiper.$swiper.slideTo(0)
          that.$refs.huahuanSwiper.$swiper.update()
        }, 1000)
      })
    },
    guibai() {
      this.guibaiFlag = true
      setTimeout(() => {
        this.guibaiFlag = false
      }, 7000)
      this.addHistory('bow')
    },
    jugong() {
      this.jugongFlag = true
      setTimeout(() => {
        this.jugongFlag = false
      }, 7000)
      this.addHistory('knees')
    },
    clearGrass() {
      this.grassShouFlag = true
      setTimeout(() => {
        this.grassShouFlag = false
      }, 7000)
      this.addHistory('grass')
    },
    jimaoClear() {
      this.jimaoClearFlag = true
      setTimeout(() => {
        this.jimaoClearFlag = false
      }, 7000)
      this.addHistory('clean')
    },
    queryHallOne() {
      var that = this
      this.$queryOne('HallInfo', { id: this.id }, this.hall, function(res) {
        that.$fill(that.hall, res['data'])
      })
    },
    jipin() {
      bus.$emit('jipin', '')
    },
    muyuan() {
      bus.$emit('muyuan', '')
    },
    queryHistory() {
      var that = this
      this.$queryAll(
        '/api/hallhistory/queryHistoryByValid',
        {
          hallId: this.id,
          sourceType: 'mem',
          sourceSubtype: 'goods',
          'myProfile.id': 'isnotnull',
          size: 10,
          sort: { createDate: 1 },
        },
        ['id,targetName,targetType,targetPhoto,validStartDate,validEndDate'],
        function(res) {
          // res.data = [
          //   {
          //     id: 10011,
          //     targetName: '平安鞭炮',
          //     targetType: 'bianpao',
          //     targetPhoto: '/files/default/jipin/bcb813e1cbf6dc07c151e946222b91d5.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10012,
          //     targetName: '感恩鞭炮',
          //     targetType: 'bianpao',
          //     targetPhoto: '/files/default/jipin/3bf5901d141d20611f8048c276a6dc84.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10013,
          //     targetName: '撒纸钱',
          //     targetType: 'huogong',
          //     targetPhoto: '/files/default/jipin/0002e00d48aeeea6475bacc6791120a0.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10014,
          //     targetName: '黄烧纸',
          //     targetType: 'huogong',
          //     targetPhoto: '/files/default/jipin/d88f64fe6ee25607accb0bb32fa586bb.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10015,
          //     targetName: '冥币',
          //     targetType: 'huogong',
          //     targetPhoto: '/files/default/jipin/53a8dbca1c8cec0a7b69156937e8c4de.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/b250937060ffb06b7fa1660d62cd8c96.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/32a1c37d353ca9bb03224f875aed8890.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/e0684290a4628cb9ed22a14d522e6b6b.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/b9616cdd36bc4565f546cd8a3d2375e4.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/d2a26fe7fba61ebead7ed9cc8d4b6f40.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/b250937060ffb06b7fa1660d62cd8c96.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/32a1c37d353ca9bb03224f875aed8890.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/e0684290a4628cb9ed22a14d522e6b6b.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/b9616cdd36bc4565f546cd8a3d2375e4.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/d2a26fe7fba61ebead7ed9cc8d4b6f40.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '富贵竹',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/682252d966e26ca96ae05006e336499d.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '富贵竹',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/5ac002827aebf19381e676a651214463.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '花圈',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/b58fe90e8b4de45ac52bfc84b51e1754.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '花圈',
          //     targetType: 'xianhua',
          //     targetPhoto: '/files/default/jipin/393b08ae2cf83857279cf096bce48ac6.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '富贵竹',
          //     targetType: 'jingjiu',
          //     targetPhoto: '/files/default/jipin/20432bf604fa12409be42391fd836c17.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '富贵竹',
          //     targetType: 'jingjiu',
          //     targetPhoto: '/files/default/jipin/54707b565b3c49ff619898e85a360590.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '花圈',
          //     targetType: 'jingjiu',
          //     targetPhoto: '/files/default/jipin/219b9ecc37b06f57a495d963e8601f30.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '花圈',
          //     targetType: 'jingjiu',
          //     targetPhoto: '/files/default/jipin/8ab19cb2912e9cc665203e92906fff38.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/8065b0dafc87c9c1c9ed472b15b43792.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/45c663639bbe2373838af66aa666c528.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/45c663639bbe2373838af66aa666c528.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/45c663639bbe2373838af66aa666c528.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/534b79e1caecd825bfafd92cebe534d2.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/b7e40a109a332cdf70b6ef772aa18ce7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/9fe3774b24e57188bfef34ad667b460a.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/71be4f842618184d9b7de659ae1fa164.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/2c2a560eb89d6d5a24e84c2517b1263a.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'shuiguo',
          //     targetPhoto: '/files/default/jipin/2598e24bf8eb324e63fdd02700d06a4b.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '馒头',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/3be721d4749f3309cb9128fa237c5ee7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '米饭',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/28d0ac5719f7328e70c6a104c13f77ed.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/3be721d4749f3309cb9128fa237c5ee7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/28d0ac5719f7328e70c6a104c13f77ed.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/50f705bedc0c7fc2c45070fa8ecae9e5.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/c9f90bb57c3d752b8250bec338dad8eb.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/92586072809ff0b2fb565f3883b8917d.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/7812fdfbeb2119ab2558c3eddcf8c175.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/f471f796c07ad0847744bbad865fe088.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/7d3a2473067d708659459a1f696d0fb9.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/33a7e98a18dbb73a28c9a8dcc89f31c0.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'gongpin',
          //     targetPhoto: '/files/default/jipin/5835e780f9c332e63c7282ba854b1dc7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },

          //   {
          //     id: 10030,
          //     targetName: '莲花灯',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/bd2e00957572d2f9652f2db0d1c5e4b7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '祈福灯',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/bd2e00957572d2f9652f2db0d1c5e4b7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '平安香',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/88dea4dbe9967ed7f533411422c7b8f7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '功德香',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/2929cf91c4f8136c95bec3a13e3b9be9.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '富贵烛',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/c8bd9f38a49b360871673c41c03e99b5.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '祈福烛',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/ae5f76463367e4a0f3cef736f828cfd9.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '祈福灯',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/3a7590addd89f521bceb8aa5648b7c09.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '平安灯',
          //     targetType: 'xiangzhu',
          //     targetPhoto: '/files/default/jipin/bd2e00957572d2f9652f2db0d1c5e4b7.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'guahua',
          //     targetPhoto: '/files/default/jipin/fb6eb29b6263a4c4b3980c3f46592bd2.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          //   {
          //     id: 10030,
          //     targetName: '',
          //     targetType: 'guahua',
          //     targetPhoto: '/files/default/jipin/2bd44e1d175190a716ddf58f8d65bdc3.png',
          //     validStartDate: '2022-08-31 17:22:53',
          //     validEndDate: '2022-09-03 17:22:53',
          //   },
          // ]
          that.historyList = res.data
          //console.log(that.historyList)
          that.huogongList = []
          that.guahuaList = []
          that.xiangzhuList = []
          that.jiuList = []
          that.shuiguoList = []
          that.shuiguoListPage = []
          that.gongpinList = []
          that.gongpinListPage = []
          that.gongpinBigList = []
          that.gongpinBigListPage = []
          that.xianhuaList = []
          that.xianhuaListPage = []
          that.zuoyouList = [] //
          that.zuoyouList1 = [] //
          that.zuoyouList1Page = [] //花圈
          that.lightList = [] //香烛，灯
          that.lazhuList = [] //香烛，蜡烛，含有 烛
          that.xlList = [] //香烛，香炉含有 炉
          let huogongList = []
          let guahuaList = []
          let xiangzhuList = []
          let jiuList = []
          let shuiguoList = []
          let gongpinList = []
          let gongpinBigList = []
          let xianhuaList = []
          let zuoyouList = []
          let zuoyouList1 = []

          let lightList = [] //香烛，灯
          let lazhuList = [] //香烛，蜡烛，含有 烛
          let xlList = [] //香烛，香炉含有 炉
          if (res.data.length > 0) {
            res.data.map(item => {
              if (item.targetType == 'bianpao' || item.targetType == 'huogong') {
                huogongList.push(item.targetPhoto)
              } else if (item.targetType == 'guahua') {
                guahuaList.push(item.targetPhoto)
              } else if (item.targetType == 'jingjiu') {
                jiuList.push(item.targetPhoto)
              } else if (item.targetType == 'shuiguo') {
                shuiguoList.push(item.targetPhoto)
              } else if (item.targetType == 'gongpin') {
                if (item.targetName.indexOf('馒头') > -1 || item.targetName.indexOf('米饭') > -1) {
                  if (item.targetName.indexOf('馒头') > -1) {
                    gongpinBigList.push(require('../../assets/jnt/food/mantou.png'))
                  } else {
                    gongpinBigList.push(require('../../assets/jnt/food/mifan.png'))
                  }
                } else {
                  gongpinList.push(item.targetPhoto)
                }
              } else if (item.targetType == 'xianhua') {
                if (
                  item.targetName.indexOf('花圈') > -1 ||
                  item.targetName.indexOf('富贵竹') > -1 ||
                  item.targetName.indexOf('天堂鸟') > -1 ||
                  item.targetName.indexOf('金钱树') > -1 ||
                  item.targetName.indexOf('万年青') > -1 ||
                  item.targetName.indexOf('发财树') > -1 ||
                  item.targetName.indexOf('平安树') > -1 ||
                  item.targetName.indexOf('幸福树') > -1 ||
                  item.targetName.indexOf('摇钱树') > -1
                ) {
                  if (item.targetName.indexOf('花圈') > -1) {
                    zuoyouList1.push(item.targetPhoto)
                  } else {
                    zuoyouList.push(item.targetPhoto)
                  }
                } else {
                  xianhuaList.push(item.targetPhoto)
                }
              } else if (item.targetType == 'xiangzhu') {
                if (item.targetName.indexOf('灯') > -1) {
                  if (item.targetName.indexOf('平安灯') > -1) {
                    lightList.push(require('../../assets/jnt/small/pingandeng.png'))
                  } else {
                    lightList.push(item.targetPhoto)
                  }
                } else if (
                  item.targetName.indexOf('烛') > -1 ||
                  item.targetName.indexOf('招财进宝') > -1
                ) {
                  lazhuList.push(item.targetPhoto)
                  // if (item.targetName.indexOf('白蜡烛') > -1) {
                  //   lazhuList.push(require('../../assets/jnt/small/bailazhu.png'))
                  // } else if (item.targetName.indexOf('宝电蜡烛') > -1) {
                  //   lazhuList.push(require('../../assets/jnt/small/baodianlazhu.png'))
                  // } else if (item.targetName.indexOf('富贵烛') > -1) {
                  //   lazhuList.push(require('../../assets/jnt/small/fuguizhu.png'))
                  // } else if (item.targetName.indexOf('招财进宝') > -1) {
                  //   lazhuList.push(require('../../assets/jnt/small/zhaocaijinbao.png'))
                  // } else if (item.targetName.indexOf('招财蜡烛') > -1) {
                  //   lazhuList.push(require('../../assets/jnt/small/zhaocailazhu.png'))
                  // } else {
                  //   lazhuList.push(item.targetPhoto)
                  // }
                } else if (item.targetName.indexOf('香') > -1) {
                  xlList.push(item.targetPhoto)
                }
              }
            })
            that.huogongList = huogongList
            that.guahuaList = guahuaList
            that.xiangzhuList = xiangzhuList
            that.jiuList = jiuList
            that.shuiguoList = shuiguoList
            that.gongpinList = gongpinList
            that.gongpinBigList = gongpinBigList
            that.xianhuaList = xianhuaList
            that.zuoyouList = zuoyouList
            that.zuoyouList1 = zuoyouList1
            that.lightList = lightList
            that.lazhuList = lazhuList //香烛，蜡烛，含有 烛
            that.xlList = xlList //香烛
            for (let sg = 0; sg < Math.ceil(that.shuiguoList.length / 7); sg++) {
              that.shuiguoListPage.push({ data: [] })
              for (let sg1 = sg * 7; sg1 < sg * 7 + 7; sg1++) {
                if (sg1 < that.shuiguoList.length) {
                  that.shuiguoListPage[sg].data.push(that.shuiguoList[sg1])
                }
              }
            }
            //console.log(that.shuiguoListPage)
            for (let xh = 0; xh < Math.ceil(that.xianhuaList.length / 7); xh++) {
              that.xianhuaListPage.push({ data: [] })
              for (let xh1 = xh * 7; xh1 < xh * 7 + 7; xh1++) {
                if (xh1 < that.xianhuaList.length) {
                  that.xianhuaListPage[xh].data.push(that.xianhuaList[xh1])
                }
              }
            }
            //console.log(that.xianhuaListPage)
            for (let gp = 0; gp < Math.ceil(that.gongpinList.length / 7); gp++) {
              that.gongpinListPage.push({ data: [] })
              for (let gp1 = gp * 7; gp1 < gp * 7 + 7; gp1++) {
                if (gp1 < that.gongpinList.length) {
                  that.gongpinListPage[gp].data.push(that.gongpinList[gp1])
                }
              }
            }

            for (let ci = 0; ci < Math.ceil(that.zuoyouList1.length / 5); ci++) {
              that.zuoyouList1Page.push({ data: [] })
              for (let ci1 = ci * 5; ci1 < ci * 5 + 5; ci1++) {
                if (ci1 < that.zuoyouList1.length) {
                  that.zuoyouList1Page[ci].data.push(that.zuoyouList1[ci1])
                }
              }
            }

            // setTimeout(() => {
            //   //this.$refs.fireSwiper.swiper
            //   that.$refs.xlSwiper.swiper()
            //   that.$refs.lazhuSwiper.swiper()
            //   that.$refs.wineSwiper.swiper()
            //   that.$refs.lightSwiper.swiper()
            //   that.$refs.circleSwiper.swiper()
            //   that.$refs.wreathSwiper.swiper()
            //   that.$refs.fruitsSwiper.swiper()
            //   that.$refs.xianhuaSwiper.swiper()
            //   that.$refs.huahuanSwiper.swiper()
            //   that.$refs.fireSwiper.swiper()
            //   that.$refs.gongpinSwiper.swiper()
            // }, 1000)
            // console.log(that.gongpinListPage)
            // for (var gpg = 0; gpg < Math.ceil(that.gongpinBigList.length / 7); gpg++) {
            //   that.gongpinBigListPage.push({ data: [] })
            //   for (var gpg1 = gpg; gpg1 < gpg * 7 + 7; gpg1++) {
            //     that.gongpinBigListPage[gpg].data.push(that.gongpinBigList[gpg1])
            //   }
            // }
          }
        }
      )
    },
    addHistory(category) {
      var param = {
        sourceType: 'mem',
        sourceSubtype: category,
        myId: this.$store.getters.userId,
        hallId: this.hall.id,
      }
      this.$submit('/api/hallhistory/addHistory', param)
    },
  },
}
</script>

<style>
/* .wine-wrap .wine1,
.wine-wrap .wine2 {
  position: absolute;
  bottom: 34.1vw;
  width: 11.73vw;
}

.wine-wrap .wine1 {
  left: 16.27vw;
}

.wine-wrap .wine2 {
  right: 16.13vw;
}

.wine-wrap .wine2-item:first-child {
  position: absolute;
  left: 0;
  bottom: 0;
}

.wine-wrap .wine1-item.wine1-right,
.wine-wrap .wine2-item:last-child {
  position: absolute;
  right: 0;
  bottom: 0;
}

.wine-wrap .wine1-item,
.wine-wrap .wine2-item {
  width: 5.28vw;
  display: block;
  cursor: pointer;
} */
.maotan {
  position: relative;
  width: 16rem;
  margin: 0 auto;
}

.zmt {
  position: absolute;
  width: 8rem;
  height: 8rem;
  background: #ccc;

  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /* Safari and Chrome */
  left: 0;
}
.maotan img {
  width: 5rem;
  height: 5rem;
}
.ymt {
  position: absolute;

  width: 8rem;
  height: 8rem;
  background: #ccc;

  animation: mymove1 3s infinite;
  -webkit-animation: mymove1 3s infinite; /* Safari and Chrome */
  right: 0;
}
@keyframes mymove {
  0% {
    top: 0px;
    transform: rotate(0deg);
  }
  50% {
    top: 200px;
    transform: rotate(100deg);
  }
  100% {
    top: 0px;
    transform: rotate(0deg);
  }
}
@keyframes mymove1 {
  0% {
    top: 0px;
    transform: rotate(0deg);
  }
  50% {
    top: 200px;
    transform: rotate(-100deg);
  }
  100% {
    top: 0px;
    transform: rotate(0deg);
  }
}
.memory-head-left,
.memory-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.memory-head-left {
  left: 0;
}
.memory-head-left,
.memory-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.memory-head .left-back {
  height: 2.5rem;
  width: 2.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.memory-head .left-back .back-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/zjt.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .left-home {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  margin-left: 10px;
}
.memory-head .left-home .home-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/tophome.png) no-repeat;
  background-size: 100% 100%;
  margin-top: -1px;
  margin-left: 1px;
}
.memory-head .center-info {
  position: fixed;
  top: 1.7rem;
  left: 7.5rem;
  z-index: 100;
  display: flex;
  display: -webkit-flex;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.center-info .family-slide .family-btn,
.center-info .follow-btn {
  padding: 0 10px;
  line-height: 2.7rem;
  color: #fff;
  text-align: center;
  border-radius: 20px !important;
}
.center-info .family-slide .family-btn {
  background: #e4803c;
  font-size: 1.09rem;
  margin-right: 1rem;
}
.center-info .follow-icon-wrap {
  display: flex;
  display: -webkit-flex;
  border-radius: 1.272rem !important;
  width: 3.6rem;
  height: 2.5rem;
}
.center-info .follow-btn,
.center-info .follow-icon-wrap {
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
}
.center-info .follow-no {
  background: url(../../assets/jnt/sc.png) no-repeat;
  background-size: 100% 100%;
}
.center-info .follow-icon {
  width: 20px;
  height: 20px;
}
.memory-head-right {
  right: 0;
}
.memory-head-left,
.memory-head-right {
  position: fixed;
  top: 1rem;
  padding: 0 10px;
}
.memory-head-left,
.memory-head-right {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  color: #333;
  padding-top: 10px;
  z-index: 100;
  box-sizing: border-box;
}
.memory-head .music-wrap {
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  margin-right: 1rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.memory-head .music-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/music.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-share {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
  margin-right: 1rem;
}
.memory-head .right-menu,
.memory-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.memory-head .right-share .share-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/zf.png) no-repeat;
  background-size: 100% 100%;
}
.memory-head .right-menu,
.memory-head .right-share {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  position: relative;
}
.memory-head .right-menu {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: rgba(0, 0, 0, 0.4);
  padding: 5px;
  box-sizing: border-box;
  border-radius: 50%;
}
.memory-head .right-menu .menu-icon {
  height: 1.545rem;
  width: 1.545rem;
  display: inline-block;
  background: url(../../assets/jnt/line3.png) no-repeat;
  background-size: 100% 100%;
}
.head-tabNav-wrap {
  position: fixed;
  top: 5.68rem;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  width: 10.91rem;
  z-index: 99;
}
.head-tabNav-wrap .tabNav-con {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item.active,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeBlack,
.head-tabNav-wrap .tabNav-con .tabNav-con-item.activeWhite {
  opacity: 1;
  filter: alpha(opacity=100);
}
.head-tabNav-wrap .tabNav-con .tabNav-con-item {
  font-size: 1.636rem;
  position: relative;
  opacity: 0.4;
  filter: alpha(opacity=40);
}
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  background-color: #fff;
}
.head-tabNav-wrap .tabNav-con .activeBlack:after,
.head-tabNav-wrap .tabNav-con .activeWhite:after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 2rem;
  height: 3px;
}
.tomb-live-wrap {
  position: fixed;
  left: 0;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 100vw;
  height: 128.267vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
  z-index: -4;
}
.tomb_stone_bg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50%;
  z-index: 2;
}
.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.tomb_stone_bg .tomb_stone_wrap {
  position: fixed;
  top: 82.13vw;

  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
}
.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.tomb_stone_bg .tomb-head-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 41.598vw;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tomb_stone_bg .tomb-head-wrap img {
  width: 7.2vw;
  height: 10.12vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: middle;
  -webkit-object-fit: cover;
  object-fit: cover;
}
.tomb_stone_bg .tomb-head-wrap .head-name {
  height: 11.73vw;
  line-height: 11.73vw;
  font-size: 12px;
  color: #fff;
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  font-family: LiSu;
  font-weight: 400;
  letter-spacing: 3px;
  display: block;
  overflow: hidden;
  margin-top: 3px;
  white-space: nowrap;
}

.candle_wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 40.5vw;
  z-index: 9;
}
.candle_wrap .free_wrap {
  width: 23.2vw;
  display: flex;
  justify-content: space-between;
  z-index: -2;
}
.candle_wrap .free_wrap,
.candle_wrap .out_wrap,
.tomb-live-wra .candle_wrap .center_wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -2px;
}
.candle_wrap .free_wrap {
  left: 0;
}
.candle_wrap .free_wrap .free-item {
  width: 3.61vw;
  display: block;
}
img {
  border: 0;
}
img {
  border-style: none;
}
div,
em,
i,
img,
input,
label {
  vertical-align: middle;
  font-style: normal;
}
.candle_wrap .free_wrap .free-item {
  width: 3.61vw;
  display: block;
}

.ground-bg,
.tomb_stone_bg {
  width: 100vw;
  vertical-align: top;
  object-fit: cover;
  -webkit-object-fit: cover;
}
.ground-bg {
  /* margin-top: 1vw;
  height: 101.33vw; */
  height: 100vw;
  background: url(../../assets/jnt/db.png) no-repeat;
  background-size: 100% 100%;
  background-position: 50%;
  z-index: -2;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap {
  width: 100%;
  background-color: #333;
  position: fixed;
  left: 0;
  bottom: 0;
  justify-content: space-between;
  padding: 1.87vw 4vw 0;
  z-index: 1000;
}
.tomb-footer-wrap .foot-item {
  width: 16.26vw;
  height: 12.79vw;
  border-top-left-radius: 4vw;
  border-top-right-radius: 4vw;
  background: linear-gradient(180deg, #5d5e60, #6d6e70);
  flex-direction: column;
  padding-top: 3px;
  color: #fff;
  font-size: 1.09rem;
  cursor: pointer;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap .special-bg {
  background: linear-gradient(180deg, #f99e29, #de5617);
}
.tomb-footer-wrap .foot-item {
  width: 16.26vw;
  height: 12.79vw;
  border-top-left-radius: 4vw;
  border-top-right-radius: 4vw;
  background: linear-gradient(180deg, #5d5e60, #6d6e70);
  flex-direction: column;
  padding-top: 3px;
  color: #fff;
  font-size: 1.09rem;
  cursor: pointer;
}
.tomb-footer-wrap,
.tomb-footer-wrap .foot-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.tomb-footer-wrap .foot-item .icon-clean-stone {
  background: url(../../assets/jnt/shou.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon {
  width: 7.74vw;
  height: 7.74vw;
  display: block;
}
.tomb-footer-wrap .foot-item .icon-weed {
  background: url(../../assets/jnt/chan.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-pray-goods {
  background: url(../../assets/jnt/jp.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-knell-down {
  background: url(../../assets/jnt/gui.png) no-repeat;
  background-size: 100% 100%;
}
.tomb-footer-wrap .foot-item .icon-bow {
  background: url(../../assets/jnt/jug.png) no-repeat;
  background-size: 100% 100%;
}

/* 草 */
.grass-wrap {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: -3vw;
  display: flex;
  justify-content: space-between;
  z-index: 1;
}

.grass-wrap #grassWrap .grass-item {
  width: 80px;
  height: 35px;
}

.grass-wrap .grass-item img {
  width: 100%;
}

.grass-wrap #grassWrap .grass-item:first-child {
  position: absolute;
  left: -1.88vw;
  bottom: 0;
}

.grass-wrap #grassWrap .grass-item:nth-child(2) {
  position: absolute;
  left: 13.35vw;
  bottom: 0;
}

.grass-wrap #grassWrap .grass-item:nth-child(3) {
  position: absolute;
  left: 36vw;
  bottom: 0;
}

.grass-wrap #grassWrap .grass-item:nth-child(4) {
  position: absolute;
  left: 59.34vw;
  bottom: 0;
}

.grass-wrap #grassWrap .grass-item:nth-child(5) {
  position: absolute;
  left: 73.86vw;
  bottom: 0;
}

.grass-wrap #grassWrap .grass-item:nth-child(6) {
  position: absolute;
  left: 8.8vw;
  bottom: -2.93vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(7) {
  position: absolute;
  left: 26.4vw;
  bottom: -2.93vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(8) {
  position: absolute;
  left: 44vw;
  bottom: -2.93vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(9) {
  position: absolute;
  left: 67.47vw;
  bottom: -2.93vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(10) {
  position: absolute;
  left: 82.13vw;
  bottom: -2.93vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(11) {
  position: absolute;
  left: -1.88vw;
  bottom: -6.45vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(12) {
  position: absolute;
  left: 14.67vw;
  bottom: -6.45vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(13) {
  position: absolute;
  left: 46.93vw;
  bottom: -6.45vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(14) {
  position: absolute;
  left: 64.53vw;
  bottom: -6.45vw;
}

.grass-wrap #grassWrap .grass-item:nth-child(15) {
  position: absolute;
  left: 79.2vw;
  bottom: -6.45vw;
}

.grass-wrap .grass_small1 {
  width: 4.14vw;
  height: 2.93vw;
  position: absolute;
  left: 32.27vw;
  bottom: 3.52vw;
}

.grass-wrap .grass_small2 {
  width: 5.34vw;
  height: 4.66vw;
  position: absolute;
  left: 57.87vw;
  bottom: 2.52vw;
}

.grass-wrap .grass-item_small1 img,
.grass-wrap .grass-item_small2 img {
  width: 100%;
}

.delayUp1 {
  animation: aniUp1 1s ease-in 0.5s forwards;
  -webkit-animation: aniUp1 1s ease-in 0.5s forwards;
}

.delayUp2 {
  animation: aniUp1 1s ease-in 1s forwards;
  -webkit-animation: aniUp1 1s ease-in 1s forwards;
}

@keyframes aniUp1 {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
    bottom: 5.87vw;
  }
  to {
    opacity: 0;
  }
}

.weedAni {
  animation: aniUp 1s ease-in forwards;
  -webkit-animation: aniUp 1s ease-in forwards;
}

@keyframes aniUp {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
    bottom: 4.4vw;
  }
  to {
    opacity: 0;
  }
}

.weed-wrap {
  top: 69vw;
}

.glove-wrap,
.weed-wrap {
  position: absolute;
  left: 0;
}

.glove-wrap {
  width: 10.94vw;
  height: 8.27vw;
  background: url(../../assets/jnt/bacao.png) no-repeat;
  background-size: 100% 100%;
  bottom: 0;
  opacity: 0;
  animation: up_3 0.5s ease-in 0.5s forwards, move_3 0.5s ease-in 1s forwards,
    up_4 0.5s ease-in 1.5s forwards, move_4 0.5s ease-in 2s forwards,
    up_5 0.5s ease-in 2.5s forwards, move_5 0.5s ease-in 3s forwards,
    up_6 0.5s ease-in 3.5s forwards, move_6 0.5s ease-in 4s forwards,
    up_7 0.5s ease-in 4.5s forwards;
  -webkit-animation: up_3 0.5s ease-in 0.5s forwards, move_3 0.5s ease-in 1s forwards,
    up_4 0.5s ease-in 1.5s forwards, move_4 0.5s ease-in 2s forwards,
    up_5 0.5s ease-in 2.5s forwards, move_5 0.5s ease-in 3s forwards,
    up_6 0.5s ease-in 3.5s forwards, move_6 0.5s ease-in 4s forwards,
    up_7 0.5s ease-in 4.5s forwards;
}

@keyframes up_1 {
  0% {
    left: 32.27vw;
    bottom: 2.52vw;
    opacity: 1;
  }
  to {
    left: 32.27vw;
    bottom: 5.87vw;
    opacity: 1;
  }
}

@keyframes move_1 {
  0% {
    left: 32.27vw;
    bottom: 5.87vw;
  }
  to {
    left: 55.73vw;
    bottom: 2.52vw;
  }
}

@keyframes up_2 {
  0% {
    left: 55.73vw;
    bottom: 2.52vw;
  }
  to {
    left: 55.73vw;
    bottom: 5.87vw;
  }
}

@keyframes move_2 {
  0% {
    left: 55.73vw;
    bottom: 5.87vw;
  }
  to {
    left: 5.87vw;
    bottom: 0;
  }
}

@keyframes up_3 {
  0% {
    left: 5.87vw;
    bottom: 0;
    opacity: 1;
  }
  to {
    left: 5.87vw;
    bottom: 4.4vw;
    opacity: 1;
  }
}

@keyframes move_3 {
  0% {
    left: 5.87vw;
    bottom: 4.4vw;
  }
  to {
    left: 19.21vw;
    bottom: 0;
  }
}

@keyframes up_4 {
  0% {
    left: 19.21vw;
    bottom: 0;
  }
  to {
    left: 19.21vw;
    bottom: 4.4vw;
  }
}

@keyframes move_4 {
  0% {
    left: 19.21vw;
    bottom: 4.4vw;
  }
  to {
    left: 39.6vw;
    bottom: 0;
  }
}

@keyframes up_5 {
  0% {
    left: 39.6vw;
    bottom: 0;
  }
  to {
    left: 39.6vw;
    bottom: 4.4vw;
  }
}

@keyframes move_5 {
  0% {
    left: 39.6vw;
    bottom: 4.4vw;
  }
  to {
    left: 64.53vw;
    bottom: 0;
  }
}

@keyframes up_6 {
  0% {
    left: 64.53vw;
    bottom: 0;
  }
  to {
    left: 64.53vw;
    bottom: 4.4vw;
  }
}

@keyframes move_6 {
  0% {
    left: 64.53vw;
    bottom: 4.4vw;
  }
  to {
    left: 79.2vw;
    bottom: 0;
  }
}

@keyframes up_7 {
  0% {
    left: 79.2vw;
    bottom: 0;
  }
  90% {
    left: 79.2vw;
    bottom: 4.4vw;
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* 鸡毛 */
.wipe-wrap {
  width: 29.33vw;
  height: auto;
  position: absolute;
  left: 50%;
  /* bottom: 73.33vw; */
  top: 20vw;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
}

.wipe-wrap .feather-duster-left,
.wipe-wrap .feather-duster-right {
  width: 14.67vw;
  height: 12.26vw;
  opacity: 0;
}

.wipe-wrap .feather-duster-left img {
  width: 100%;
}

.wipe-wrap .feather-duster-right img {
  height: 100%;
}

.wipe-wrap .feather-duster-left {
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0;
  -webkit-transform-origin: 0;
  animation: leftClean 2s ease-in-out 3, aniDown 2s linear 3;
  -webkit-animation: leftClean 2s ease-in-out 3, aniDown 2s linear 3;
}

.wipe-wrap .feather-duster-right {
  position: absolute;
  right: 0;
  top: 0;
  transform-origin: right;
  -webkit-transform-origin: right;
  animation: rightClean 2s ease-in-out 0.5s 3, aniDown 2s linear 0.5s 3;
  -webkit-animation: rightClean 2s ease-in-out 0.5s 3, aniDown 2s linear 0.5s 3;
}

@keyframes leftClean {
  0% {
    opacity: 1;
    transform: rotate(-20deg);
    -webkit-transform: rotate(-20deg);
  }
  50% {
    transform: rotate(50deg);
    -webkit-transform: rotate(50deg);
  }
  99% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: rotate(-20deg);
    -webkit-transform: rotate(-20deg);
  }
}

@keyframes aniDown {
  0% {
    top: 0;
  }
  50% {
    top: 50px;
  }
  to {
    top: 0;
  }
}

@keyframes rightClean {
  0% {
    opacity: 1;
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  50% {
    transform: rotate(-60deg);
    -webkit-transform: rotate(-60deg);
  }
  99% {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
}

.shine {
  background: url(../../assets/jnt/sg.jpg) no-repeat;
  background-size: 100% 100%;
  opacity: 0;
}

.shine1 {
  width: 5.57vw;
  height: 5.57vw;
  left: 2.93vw;
  top: 0;
  animation: opacity-change 1s ease-in-out 6.5s 1;
  -webkit-animation: opacity-change 1s ease-in-out 6.5s 1;
}

.shine1,
.shine2 {
  position: absolute;
}

.shine2 {
  width: 4.4vw;
  height: 4.4vw;
  right: 5.87vw;
  top: 2.93vw;
  animation: opacity-change 1s ease-in-out 6.8s 1;
  -webkitanimation: opacity-change 1s ease-in-out 6.8s 1;
}

.shine3 {
  width: 5.87vw;
  height: 5.87vw;
  right: 11.73vw;
  top: 14.67vw;
  animation: opacity-change 1s ease-in-out 7.2s 1;
  -webkit-animation: opacity-change 1s ease-in-out 7.2s 1;
}

.shine3,
.shine4 {
  position: absolute;
}

.shine4 {
  width: 5.28vw;
  height: 5.28vw;
  left: 14.67vw;
  top: 26.4vw;
  animation: opacity-change 1s ease-in-out 6.7s 1;
  -webkit-animation: opacity-change 1s ease-in-out 6.7s 1;
}

.shine5 {
  width: 5.57vw;
  height: 5.57vw;
  position: absolute;
  left: 2.93vw;
  top: 20.53vw;
  animation: opacity-change 1s ease-in-out 7s 1;
  -webkit-animation: opacity-change 1s ease-in-out 7s 1;
}

@keyframes opacity-change {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* guigai */
.bow-wrap {
  position: absolute;
  left: 50%;
  bottom: 17.6vw;
  transform: translateX(-50%);
  z-index: 99;
}

.bow-wrap .svg-img {
  width: 22.93vw;
  height: 49.6vw;
}
/* 绿植 */
.wreath-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  top: 38vw;

  z-index: 9;
}

.wreath-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20vw;
}

.wreath-left,
.wreath-right {
  width: 22vw;
  cursor: pointer;
  bottom: 13.2vw;
}

.wreath-left img,
.wreath-right img {
  width: 100%;
  display: block;
}
/* circle */
/* .circle-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -50vw;
  padding: 0 3rem;
  z-index: 9;
}

.circle-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 16vw;
}

.circle-left,
.circle-right {
  width: 16.81vw;
  cursor: pointer;
  bottom: 13.2vw;
}

.circle-left img,
.circle-right img {
  width: 100%;
  display: block;
} */

.circle-wrap {
  width: 100%;
  padding: 0 5.87vw;
  position: absolute;
  left: 0;
  top: 50vw;
  box-sizing: border-box;
  z-index: 10;
}

.xhflex-list {
  display: flex;
  justify-content: space-around;
}

.circle-wrap .circle-item {
  width: 17vw;
  display: block;
  cursor: pointer;
  margin-top: 0.5rem;
}

/* jiu */
.wine-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  top: 38vw;
  padding: 0 18vw;
  z-index: 9;
}

.wine-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wine-left,
.wine-right {
  width: 16.81vw;

  cursor: pointer;
  bottom: 13.2vw;
}

.wine-left img,
.wine-right img {
  width: 100%;
  display: block;
}
.lazhu-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  top: 40vw;
  padding: 0 38vw;
  z-index: 9;
}

.lazhu-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lazhu-left,
.lazhu-right {
  width: 5vw;
  cursor: pointer;
  bottom: 13.2vw;
}

.lazhu-left img,
.lazhu-right img {
  width: 100%;
  display: block;
}
/* 灯 */
.light-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  top: 38vw;
  padding: 0 26vw;
  z-index: 9;
}

.light-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.light-left,
.light-right {
  width: 16.81vw;
  cursor: pointer;
  bottom: 13.2vw;
}

.light-left img,
.light-right img {
  width: 100%;
  display: block;
}

.fruits-wrap {
  width: 100%;
  padding: 0 5.87vw;
  position: absolute;
  left: 0;
  bottom: -21.5vw;
  box-sizing: border-box;
  z-index: 10;
}

.flex-list {
  display: flex;
  justify-content: space-around;
}

.fruits-wrap .fruits-item {
  width: 9.33vw;
  display: block;
  cursor: pointer;
  margin-top: 0.5rem;
}
/* hua */
.xianhua-wrap {
  width: 100%;
  padding: 0 5.87vw;
  position: absolute;
  left: 0;
  bottom: -13vw;
  box-sizing: border-box;
  z-index: 10;
}

.xhflex-list {
  display: flex;
  justify-content: space-around;
}

.xianhua-wrap .xianhua-item {
  width: 9.33vw;
  display: block;
  cursor: pointer;
  margin-top: 0.5rem;
}
/* hua */
.gongpin-wrap {
  width: 100%;
  padding: 0 5.87vw;
  position: absolute;
  left: 0;
  bottom: -28.5vw;
  box-sizing: border-box;
  z-index: 10;
}

.gpflex-list {
  display: flex;
  justify-content: space-around;
}

.gongpin-wrap .gongpin-item {
  width: 9.33vw;
  display: block;
  cursor: pointer;
  margin-top: 0.5rem;
}

.flowers-wrap {
  width: 100%;
  padding: 0 8.8vw;
  position: absolute;
  left: 0;
  bottom: 2.53vw;
  box-sizing: border-box;
}

.flowers-wrap .flower-item {
  width: 11.73vw;
  display: block;
  cursor: pointer;
}

.hangFlowers-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 70vw;
  width: 154px;
  z-index: 9;
}

.hangFlowers-wrap img {
  width: 100%;
}

.fireSwiper-wrap {
  position: fixed;
  left: 0;
  top: 20vw;
  width: 15vw;
  z-index: 20;
  cursor: pointer;
}

.fireSwiper-wrap img {
  width: 100%;
  display: block;
}

.foods-wrap {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -75vw;
  z-index: 20;
}

.foods-wrap .foods-con1,
.foods-wrap .fd-img {
  width: 100%;
  position: absolute;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  box-sizing: border-box;
}

.foods-wrap .fd-img {
  padding: 0 1vw;
  bottom: 37.46vw;
}

.foods-wrap .fd-img .food-item {
  width: 11.15vw;
  cursor: pointer;
}

.foods-wrap .food-item {
  width: 11.73vw;
  cursor: pointer;
}

.foods-wrap .food-item .big-rice {
  width: 23.99vw;
}
.foods-wrap .big-rice {
  width: 30vw;
}
.foods-wrap .foods-con3 .con3-left,
.foods-wrap .foods-con3 .con3-right {
  position: absolute;
  bottom: 25.46vw;
  width: 28vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.foods-wrap .foods-con3 .con3-left {
  left: 4vw;
}

.foods-wrap .foods-con3 .con3-right {
  right: 4vw;
}

.tomb_stone_bg .tomb-head-wrap.double-wrap {
  width: 16.808vw;
  flex-direction: row;
  justify-content: space-between;
  top: -10rem;
}
.tomb_stone_bg .tomb-head-wrap {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 41.598vw;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tomb_stone_bg .tomb-head-wrap.double-wrap img {
  width: 7.198vw;
  height: 8.8vw;
}
.tomb_stone_bg .tomb-head-wrap img {
  width: 7.2vw;
  height: 10.12vw;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: middle;
  -webkit-object-fit: cover;
  object-fit: cover;
}
.tomb_stone_bg .tomb-head-wrap .head-name {
  height: 11.73vw;
  line-height: 11.73vw;
  font-size: 1.09rem;
  color: #fff;
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  font-family: LiSu;
  font-weight: 400;
  letter-spacing: 3px;
  display: block;
  margin-top: 3px;
  white-space: nowrap;
}
.tomb_stone_bg .tomb-head-wrap.double-wrap .head-item {
  width: 7.198vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.candle_wrap .center_wrap {
  width: 15vw;
  /* bottom: -10px; */
  cursor: pointer;
  z-index: 1;
}

.candle_wrap .center-item {
  width: 100%;
  height: auto;
}
.tomb-footer-wrap .special-bg {
  background: linear-gradient(180deg, #f99e29, #de5617);
}
</style>